import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import VueKeyCloak from '@dsb-norge/vue-keycloak-js'
import VueClipboard from 'vue-clipboard2'
import VueAnnouncer from 'vue-announcer'
import axios from 'axios'

import '@/assets/custom.scss'


export const eventBus = new Vue();

Vue.config.productionTip = false
Vue.use(BootstrapVue)

function tokenInterceptor () {
  axios.interceptors.request.use(config => {
    if (config.ignoreHeader && config.ignoreHeader === true) {
      return config
    }
    config.headers.Authorization = `Bearer ${Vue.prototype.$keycloak.token}`
    return config
  }, error => {
    return Promise.reject(error)
  })
}

Vue.use(VueClipboard)

Vue.use(VueKeyCloak, {
  init: {
    onLoad: 'login-required'  },
  config: {
    url: 'https://authenticator4.web.health.state.mn.us/auth',
    // url: 'https://authenticator4.nonprod.health.state.mn.us/auth',
    clientId: 'cloud-drive-app',
    realm: 'mnit-realm'
  },
  onReady: kc => {
    tokenInterceptor()
    /* eslint-disable no-new */
    new Vue({
      VueAnnouncer,
      router,
      render: h => h(App)
    }).$mount('#app')
  }
})
